/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import * as THREE from 'three'
import React, {useEffect, useLayoutEffect, useRef} from 'react'
import { useGLTF } from '@react-three/drei'
import { GLTF } from 'three/examples/jsm/loaders/GLTFLoader'
import {IS_MOBILE, ROOT_PATH_PREFIX} from "../../../common/const";
import {useLoader, useThree} from "@react-three/fiber";
import {EXRLoader} from "three/examples/jsm/loaders/EXRLoader";
import {useEquirectEXR} from "../../../../utils/useEquirect";
import {disposeScene, setupScene} from "../../../../utils/disposeScene";
import {GLTFLoader} from "three-stdlib";
import {useKTXLoader} from "../../../../utils/useKTXLoader";
import useProductStore, {productDic} from "../../../../stores/productStore";

type GLTFResult = GLTF & {
    nodes: {
        a_props_basket005: THREE.Mesh
        c_wall_02004: THREE.Mesh
        c_door005: THREE.Mesh
        c_door_handle004: THREE.Mesh
        d_ceiling_light010: THREE.Mesh
        d_ceiling_light_glass005: THREE.Mesh
        glass005: THREE.Mesh
        b_props_module_02005: THREE.Mesh
        d_ceiling_light_deco005: THREE.Mesh
        a_furniture_01_shelf004: THREE.Mesh
        a_props_module_01005: THREE.Mesh
        b_furniture_02005: THREE.Mesh
        b_furniture_02001: THREE.Mesh
        b_furniture_02_marble004: THREE.Mesh
        d_props_towel005: THREE.Mesh
        d_floor005: THREE.Mesh
    }
    materials: {
        mat_props_basket: THREE.MeshStandardMaterial
        mat_wall_01: THREE.MeshStandardMaterial
        mat_door: THREE.MeshStandardMaterial
        ['mat_metal.002']: THREE.MeshStandardMaterial
        mat_led: THREE.MeshStandardMaterial
        mat_glass: THREE.MeshStandardMaterial
        mat_props_module_02: THREE.MeshStandardMaterial
        mat_ceiling_light_deco: THREE.MeshStandardMaterial
        ['mat_cerused_maple_wood.002']: THREE.MeshStandardMaterial
        mat_props_module_01: THREE.MeshStandardMaterial
        mat_cerused_maple_wood_3: THREE.MeshStandardMaterial
        mat_yule_marble: THREE.MeshStandardMaterial
        mat_towel: THREE.MeshStandardMaterial
        mat_floor: THREE.MeshStandardMaterial
    }
}

const GLTF_URL = IS_MOBILE ?
    (ROOT_PATH_PREFIX + '/RP/rooms/laundry/m/laundry_wood_ktx2.glb') :
    (ROOT_PATH_PREFIX + '/RP/rooms/laundry/laundry_wood_ktx2.glb');
// const GLTF_URL = ROOT_PATH_PREFIX + '/RP/rooms/laundry/laundry_wood_ktx2.glb';
const LIGHT_MAP_URL = IS_MOBILE ?
    (ROOT_PATH_PREFIX + '/RP/rooms/laundry/map/laundry_cyclesbake_DIFFUSE_m.exr') :
    (ROOT_PATH_PREFIX + '/RP/rooms/laundry/map/laundry_cyclesbake_DIFFUSE.exr');
const ENV_URL = ROOT_PATH_PREFIX + '/RP/rooms/laundry/map/laundry_cyclesbake_Environment_01.exr';

export default function Model(props: JSX.IntrinsicElements['group']) {
    const group = useRef<THREE.Group>()
    const {nodes, materials, scene} = useKTXLoader<GLTFResult>(GLTF_URL);

    // @ts-ignore
    const lightmapTex = useLoader(EXRLoader, LIGHT_MAP_URL, (loader: EXRLoader) => {
        if (IS_MOBILE) {
            loader.setDataType(THREE.HalfFloatType);
        } else {
            loader.setDataType(THREE.FloatType);
        }
    });
    const envTex = useEquirectEXR(ENV_URL);
    const gl = useThree(state => state.gl);
    const scene2 = useThree(state => state.scene);

    useLayoutEffect(()=>{
        lightmapTex.flipY = true;
        lightmapTex.needsUpdate = true;

        scene2.environment = envTex;
        gl.toneMappingExposure = 1;

        setupScene(scene, lightmapTex);
        materials.mat_props_module_02.lightMapIntensity = 3;
        materials.mat_yule_marble.lightMapIntensity = 2;
        materials.mat_led.emissiveIntensity = 10;
        materials["mat_metal.002"].envMapIntensity = 3;

    }, [lightmapTex, envTex]);

    useEffect(() => {
        console.log("===>", productDic['styler']);
        console.log("===>", productDic['washer_n_dryer']);

        return () => {
            disposeScene(scene);
            lightmapTex.dispose();
            envTex.dispose();
            useLoader.clear(GLTFLoader, ROOT_PATH_PREFIX + '/models/rooms/lghome/laundry_wood_ktx2.glb');
        }
    }, []);

    const selectedCategory = useProductStore(state => state.selectedCategory);
    const selectedProduct = useProductStore(state => state.selectedProduct);
    const dummyPlaneRef = useRef<THREE.Mesh>(null!);
    const dummyPlaneRef2 = useRef<THREE.Mesh>(null!);   //바닥용
    useEffect(()=> {
        if(selectedProduct && selectedCategory)
        {
            if(selectedCategory.category === 'styler'){
                dummyPlaneRef.current.visible = selectedProduct.modelNo !== 'baron';
            }
            else if(selectedCategory.category === 'washer_n_dryer')
            {
                dummyPlaneRef2.current.visible = selectedProduct.modelNo === 'washtower';
            }
        }
    }, [selectedProduct]);

    return (
        <group ref={group} {...props} dispose={null}>
            <group
                position={[10, 0, 0]}
                rotation={[Math.PI / 2, 0, 0]}
                scale={[0.01, 0.01, 0.01]}
                userData={{ name: 'Laundry_Room' }}>
                <group userData={{ name: 'HA_LifeStyle_LaundryRoom' }}>
                    <group userData={{ name: 'HA_LifeStyle_Object' }}>
                        <mesh
                            geometry={nodes.a_props_basket005.geometry}
                            material={materials.mat_props_basket}
                            userData={{ name: 'a_props_basket.005' }}
                        />
                    </group>
                </group>
                <group userData={{ name: 'Wall_1' }}>
                    <mesh
                        geometry={nodes.c_wall_02004.geometry}
                        material={materials.mat_wall_01}
                        userData={{ name: 'c_wall_02.004' }}
                    />
                </group>
            </group>
            <mesh
                geometry={nodes.c_door005.geometry}
                material={materials.mat_door}
                userData={{ name: 'c_door.005' }}
            />
            <mesh
                geometry={nodes.c_door_handle004.geometry}
                material={materials['mat_metal.002']}
                userData={{ name: 'c_door_handle.004' }}
            />
            <mesh
                geometry={nodes.d_ceiling_light010.geometry}
                material={materials.mat_led}
                userData={{ name: 'd_ceiling_light.010' }}
            />
            <mesh
                geometry={nodes.d_ceiling_light_glass005.geometry}
                material={nodes.d_ceiling_light_glass005.material}
                userData={{ name: 'd_ceiling_light_glass.005' }}
            />
            <mesh
                geometry={nodes.glass005.geometry}
                material={nodes.glass005.material}
                userData={{ name: 'glass.005' }}
            />
            <mesh
                geometry={nodes.b_props_module_02005.geometry}
                material={materials.mat_props_module_02}
                userData={{ name: 'b_props_module_02.005' }}
            />
            <mesh
                geometry={nodes.d_ceiling_light_deco005.geometry}
                material={materials.mat_ceiling_light_deco}
                userData={{ name: 'd_ceiling_light_deco.005' }}
            />
            <mesh
                geometry={nodes.a_furniture_01_shelf004.geometry}
                material={materials['mat_cerused_maple_wood.002']}
                userData={{ name: 'a_furniture_01_shelf.004' }}
            />
            <mesh
                geometry={nodes.a_props_module_01005.geometry}
                material={materials.mat_props_module_01}
                userData={{ name: 'a_props_module_01.005' }}
            />
            <mesh
                geometry={nodes.b_furniture_02005.geometry}
                material={nodes.b_furniture_02005.material}
                position={[-0.0119, 0, 0]}
                userData={{ name: 'b_furniture_02.005' }}
            />
            <mesh
                geometry={nodes.b_furniture_02001.geometry}
                material={nodes.b_furniture_02001.material}
                position={[-1.178, 0, -0.05]}
                scale={[1.6,1,1]}
                userData={{ name: 'b_furniture_02.001' }}
                ref={dummyPlaneRef2}
            />
            <mesh
                ref={dummyPlaneRef}
                position={[3.125, 1, -4.65]}
                material={nodes.b_furniture_02001.material}>
                <boxBufferGeometry args={[0.11,2.1,1]} />
            </mesh>
            <mesh
                geometry={nodes.b_furniture_02_marble004.geometry}
                material={materials.mat_yule_marble}
                userData={{ name: 'b_furniture_02_marble.004' }}
            />
            <mesh
                geometry={nodes.d_props_towel005.geometry}
                material={materials.mat_towel}
                userData={{ name: 'd_props_towel.005' }}
            />
            <mesh
                geometry={nodes.d_floor005.geometry}
                material={materials.mat_floor}
                userData={{ name: 'd_floor.005' }}
            />
        </group>
    )
}
